import React from "react";
import SelectionRow from "./SelectionRow";
import { formatTimePeriod } from "@ui/i18n/formatDate";
import t from "../../../../i18n";
import { analysesRatioFormat } from "./utils";
import { styled } from "@linaria/react";

interface Props {
  total: number;
  totalPossible: number;
  timeWindowInMS: number;
}

const AnalysesSelectionSummary: React.FC<Props> = ({ total, totalPossible, timeWindowInMS }) => (
  <SelectionInformation>
    <SelectionRow
      label={t("measures.chart.selected.analyses.modal.deactivate.information.analyses")}
      value={total}
    />
    <SelectionRow
      weight="light"
      label={t("measures.chart.selected.analyses.modal.deactivate.information.data_points")}
      value={totalPossible}
    />
    <SelectionRow
      label={t("measures.chart.selected.analyses.modal.deactivate.information.selected_period")}
      value={formatTimePeriod(timeWindowInMS)}
    />
    <SelectionRow
      value={analysesRatioFormat(total, timeWindowInMS)}
      label={t(
        "measures.chart.selected.analyses.modal.deactivate.information.current_analysis_frequency",
      )}
    />
  </SelectionInformation>
);

const SelectionInformation = styled.div`
  display: flex;
  flex-direction: column;
`;
export default AnalysesSelectionSummary;
